<template>
  <div class="krds-pagination">
      <template>
        <span @click="pagingInfo.prevPage > 0 && doPage(1)" class="page-navi prev more-prev" :class="[{ disabled: pagingInfo.prevPage <= 0 }, pagingInfo.prevPage > 0 ? 'curs-p' : '']"></span>
        <span @click="pagingInfo.prevPage > 0 && doPage(pagingInfo.prevPage)" class="page-navi prev" :class="[{ disabled: pagingInfo.prevPage <= 0 }, pagingInfo.prevPage > 0 ? 'curs-p' : '']"></span>
      </template>
      <div class="page-links">
        <a v-for="index in (pagingInfo.lastPage - pagingInfo.firstPage) + 1" :key="index" class="page-link curs-p" :class="{ active: (index + pagingInfo.firstPage) - 1 == currentPage }" @click="doPage((index+pagingInfo.firstPage)-1)">{{ (index+pagingInfo.firstPage) - 1 }}</a>
      </div>
      <template>
        <a @click="pagingInfo.nextPage > 0 && doPage(pagingInfo.nextPage)" class="page-navi next curs-p" :class="[{ disabled: pagingInfo.nextPage <= 0 }, pagingInfo.nextPage > 0 ? 'curs-p' : '']"></a>
        <a @click="pagingInfo.nextPage > 0 && doPage(pagingInfo.totalPage)" class="page-navi next more-next curs-p" :class="[{ disabled: pagingInfo.nextPage <= 0 }, pagingInfo.nextPage > 0 ? 'curs-p' : '']"></a>
      </template>
    </div>
</template>

<script>
export default {
  props: {
    pagingInfo: {
      type: Object
    },
    currentPage: {
    }
  },
  methods: {
    doPage(index) {
      this.$emit("input", index)
    },
  }
}
</script>